export const WORKSPACE_LIST_ENTITY_NAME = 'WorkspaceList';
export const WORKSPACE_ENTITY_NAME = 'Workspace';
